import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserItems, UserLogin } from 'src/app/classes/interfaces/useritems.interface';
import { PlatformService } from 'src/app/classes/services/platform.service';
import { Utils } from 'src/app/classes/utils';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { ModalService } from 'src/app/shared/modal/services/modal.service';
import { Location } from '@angular/common';
import { NavigationService } from 'src/app/classes/services/navigation.service';
import { IMenuItem } from 'src/app/classes/interfaces/menu-item';

enum Device {
  Mobile = 'sm',
  Laptop = 'lg',
}
@Component({
  selector: 'app-header-layout',
  templateUrl: './header-layout.component.html',
  styleUrls: ['./header-layout.component.scss'],
})
export class HeaderLayoutComponent {
  user$;
  loggedIn$ = AuthService.loggedIn.asObservable();
  sendDate = true;
  loggedIn = false;
  linkPanelMobile : string;
  userNameMobile : string;
  menuItems : Array<IMenuItem>;

  userLogin : Array<UserLogin> = [
    {
      text : 'ورود',
      type : 'login',
      color : '#3246d3',
      bg : '#ffff'
    },
    {
      text : 'عضویت',
      type : 'sign-up',
      color : '#ffff',
      bg : '#3246d3',
    },
  ];
  
  userItems: Array<UserItems> = [
    {
      icon: 'header-login-icon',
      isLink: false,
      sub: [
        { text: 'خروج'},
      ],
    },
    {
      icon: 'header-panel-icon',
      isLink: true,
      link: '',
      sub: [
        { text: 'پروفایل' },
      ],
    },
    {
      icon: 'avatar-user-icon',
      isLink: false,
      sub: [
        { text: '' },
      ],
    },
  ];


  device = 'lg';
  static modalView = '';
  static modalStatus: boolean = false;
  modalWidth: string = '';
  get _modalStatus() {
    return HeaderLayoutComponent.modalStatus;
  }
  constructor(
    private platform: PlatformService,
    private modal: ModalService,
    private _router: Router,
    private _auth: AuthService,
    private toastr: ToastrService,
    private location: Location,
    private navService: NavigationService,
    )
  {
    this.navService.menuItems$.subscribe((items) => {
      this.menuItems = items;
    });
    this.loggedIn$.subscribe((res) => {
      this.loggedIn = res;
    });
    this.user$ = this._auth.userSubject.asObservable();
  }

  ngOnInit() {
    this.getUserItem();
    this.updateDeviceValue();
    this.getRoute();
  }
    // ==========[اضافه کردن کد رفرال و لینک رفرال]=======
   refralCode : string | null;

    getRoute(){
      this._router.events.subscribe({
        next: (event) => {
          if(event instanceof NavigationEnd) {
            let route = event.urlAfterRedirects;
            if(route.startsWith('/shop/atm-expert?RL') || route.startsWith('/shop/propex-expert?RL')){
              this.pushRefralCode(route.split('='));
            }
          }
        }
      });  
    }
  
    pushRefralCode(route : any){
      this.refralCode = route.pop();
      this.openModal('sign-up');
    }

    openModal(type: string) {
      HeaderLayoutComponent.modalView = type;
  
      this.modal.open().subscribe({
        next: (action) => {
          console.log(action);
        },
        complete: () => {
          HeaderLayoutComponent.modalStatus = false;
        },
      });
      HeaderLayoutComponent.modalStatus = true;
    }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateDeviceValue();
  }
  updateDeviceValue() {
    if (this.platform.isPlatformBrowser()) {
      if (Utils.isTablet()) {
        this.modalWidth = '60vw';
        this.device = Device.Mobile;
      } else {
        if (Utils.isLaptopLg()) {
          this.modalWidth = '60vw';
        } else {
          this.modalWidth = '100%';
        }
        this.device = Device.Laptop;
      }
    }
  }
  openedModal(event: any) {
    HeaderLayoutComponent.modalView = event;
    
    this.modal.open().subscribe({
      next: (action) => {
        console.log(action);
      },
      complete: () => {
        HeaderLayoutComponent.modalStatus = false;
      },
    });
    HeaderLayoutComponent.modalStatus = true;
  }
  get _modalView() {
    return HeaderLayoutComponent.modalView;
  }

  getUserItem(){
    this.user$.subscribe({
      next: async (val) => {
        if (val.token !== '') {
          this.userItems[2].sub[0].text = val.firstName + ' ' + val.lastName
          this.userNameMobile = val.firstName + ' ' + val.lastName
          this.userItems[1].link = `https://panel.iraniexpert.com/#/checkUserPermission?token=${val.token}`;
          this.linkPanelMobile = `https://panel.iraniexpert.com/#/checkUserPermission?token=${val.token}`;
        }
        this.sendDate = true;
      },
    });
  }

   logOut() {
      this._auth.logOutUser();
      this.toastr.show('برای استفاده از امکانات سایت مجددا وارد شوید', 'از حساب خارج شدید', {
        positionClass: 'toast-top-left',
        progressBar: true,
        closeButton: true,
        toastClass: 'ngx-toastr toast-logged-out',
      });
      if (this._router.url.includes('checkout')) {
        this.location.back();
      }
    }
}
